module.exports = __webpack_public_path__ + "img/03.45fb59bc.jpg";